module.exports = __webpack_public_path__ + "img/akusherstij-stacioner1.1228ee80.jpg";